<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .field-label {
    font-weight: 500;
    color: colors.get(textBlack);
  }

  .mandatory-tooltip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: colors.get(primary_50);
    color: colors.get(textWhite);
    padding: utils.in_rem(2px) utils.in_rem(4px);
    border-radius: var(--border-radius-sm);
    font-size: 0.75rem;
    margin-left: utils.in_rem(4px);
    font-weight: bold;
  }
</style>

<script>
  export let field;
</script>

<span class="field-label">{field.label}</span>
{#if field.required}
  <span class="mandatory-tooltip">M</span>
{/if}
